import React from 'react';
import {
    MyQuotationData,
    MyQuotationsHeadCellContent,
} from '../../models/quotations/Quotations';
import { TableLoadingLayout } from '../layouts/LoadingLayouts/TableLoadingLayout';
import useMyQuotationsSWR from '../../hooks/quotations/useMyQuotationsSWR';
import { useTranslation } from 'react-i18next';
import { MY_QUOTATION_HEAD_CELLS } from '../../utils/constans/tableHeads/quotationTableHeadCells';
import { MyQuotationsTableRow } from './MyQuotationsTableRow';
import { GeneralTable } from '../shared/Table/GeneralTable';
import { Box } from '@mui/material';

export const MyQuotationsTable = () => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'MY_QUOTATIONS',
    });
    const { quotes, isLoading, isError } = useMyQuotationsSWR();

    const tableHeadSettings = {
        translateNs: 'quotations',
        translatePrefix: 'QUOTATIONS.TABLE_HEAD',
        selectable: false,
        headContent: MY_QUOTATION_HEAD_CELLS,
    };

    const tableToolbarSettings = {
        translateNs: 'quotations',
        translatePrefix: 'MY_QUOTATIONS.TABLE_TOOLBAR',
    };

    const filterTerm = (search) => {
        return quotes.filter((elem) => {
            return (
                elem.quoteNo.toString().includes(search) ||
                elem.status.toLowerCase().includes(search.toLowerCase())
            );
        });
    };

    return (
        <>
            {isError && <Box>{t('LOADING_ERROR')}</Box>}
            {isLoading && <TableLoadingLayout />}
            {!isLoading && quotes && (
                <GeneralTable<MyQuotationData, MyQuotationsHeadCellContent>
                    fullList={quotes}
                    rowComponent={MyQuotationsTableRow}
                    filterTerm={filterTerm}
                    defaultOrderBy={'quoteNo'}
                    defaultOrder={'desc'}
                    selectHandleId={'quoteID'}
                    tableHeadSettings={tableHeadSettings}
                    tableToolbarSettings={tableToolbarSettings}
                    isLoading={isLoading}
                />
            )}
        </>
    );
};
